module.exports = __webpack_public_path__ + "static/media/hero-bg.82c9a384.png";